<template>
  <div class="cardCustom">
    <div class="card cardCustom__side">
      <div class="cardCustom__header">
        <div class="cardCustom__header-text">
          <span class="uppercase">
            {{ title }}
          </span>
        </div>
        <div class="cardCustom__header-info__item">
          <button
            v-if="infoText"
            v-tooltip="{
              content: infoText,
              placement: 'bottom-center',
              classes: ['info'],
            }"
          >
            <i class="fas fa-info-circle" />
          </button>
        </div>
      </div>
      <div class="content pt-3 pb-3 small">
        <div v-if="loading" :class="{ bgBlur: true }" :style="blurStyles"></div>
        <line-chart :chartData="chartData" :options="options" :styles="myStyles"></line-chart>
        <div v-if="loading" class="loadingSection lds-dual-ring"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Card from './Card.vue';
import CardWithSides from '@/components/Cards/CardWithSides';
import BarChart from '../../controllers/Charts/BarChart';
import LineChart from '@/controllers/Charts/LineChart';

export default {
  name: 'LineChartCard',
  components: {
    LineChart,
    CardWithSides,
    Card,
  },
  props: {
    chartHeight: Number,
    loading: Boolean,
    infoText: String,
    title: String,
    subTitle: String,
    chartData: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },
  computed: {
    myStyles() {
      return {
        height: `${this.chartHeight}px`,
        position: 'relative',
      };
    },
    blurStyles() {
      return {
        height: `${this.chartHeight}px`,
      };
    },
  },
};
</script>
<style>
.small {
  margin-top: 3rem;
}
</style>
